export default "__VITE_ASSET__Bucrkhwo__"